module.exports = __webpack_public_path__ + "img/sarah_broecker_10.84049b98.jpg";